export enum freegameAssetConfig {







    //multiplierFrameFG = "assets/freegame/Multiplier_frame.png",

    Fg_frame = "assets/freegame/freegame_reel.png",

    freegameLeave = "assets/freegame/freegame.json",
    total_win_meter_fg = "assets/freegame/total_win_meter_fg.png",
    fg_bottom_grass = "assets/freegame/fg_bottom_grass.png",
    fg_front_grass = "assets/freegame/fg_front_grass.png",
    fg_banner = "assets/freegame/fg_banner.png",
    continue_btns_banner = "assets/freegame/intro_screen_btn.json",

}